import {SimpleList, Text} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';
import {SectionWrapper} from './SectionWrapper';

export const RegularSection: FC<{
  label?: string;
  bulletPoints: string[];
  additionalText?: string;
}> = ({label, bulletPoints, additionalText}) => {
  return (
    <SectionWrapper dataTestId={`productDetailsRegularSection_${label}`}>
      <StyledDescriptionDetails>
        {bulletPoints.length > 0 && <SimpleList>{bulletPoints}</SimpleList>}
        {additionalText && (
          <AdditionalText size="px14">{additionalText}</AdditionalText>
        )}
      </StyledDescriptionDetails>
    </SectionWrapper>
  );
};

const StyledDescriptionDetails = styled.dd`
  margin-inline-start: 0;
`;

const AdditionalText = styled(Text)`
  white-space: pre-line;
`;
